import * as React from 'react';
import { Row, Col, DatePicker, Divider, Button, Checkbox } from 'antd';
import moment from 'moment';
import { TSInput } from '../common/TSInput';
import { Bussiness, CompanyNodeEdge } from '../master/Company/constants';
import { ProductDropDown } from '../master/Product/ProductDropdown';
import { ProductNode } from '../../schema';
import { KhadiPhysicalStockNode } from './Constants';

export const KhadiPhysicalStockForm: React.FunctionComponent<Props> = (
  props,
) => {
  const grossValue =
    props.value.productDetails?.reduce((total, product, index) => {
      const rate = product.rate || 0;
      const physicalQty = props.value.physicalStocks?.[index] || 0;
      return total + rate * physicalQty;
    }, 0) || 0;
  return (
    <Row>
      <Col span={8}>
        <DatePicker
          value={
            props.value.date
              ? moment(props.value.date)
              : moment(moment().format('YYYY-MM-DD'))
          }
          onChange={(e) =>
            props.onChange({
              target: {
                name: 'date',
                value: e && moment(e).format('YYYY-MM-DD'),
              },
            })
          }
          placeholder="Date"
          format="DD-MM-YYYY"
          style={{ margin: '5px 0', width: '100%' }}
        />
      </Col>
      <Col span={10}>
        <TSInput
          error={''}
          key="id"
          name="branchId"
          value={props.currentBusiness.name}
          addonBefore="Branch"
        />
      </Col>
      <Col span={6}>
        <TSInput
          error={''}
          key="id"
          name="branchId"
          value={grossValue}
          addonBefore="Gross Value"
        />
      </Col>
      <Divider />
      <h4>Products</h4>
      <Row>
        <Col span={1}>Sl. No.</Col>
        <Col span={3}>Product</Col>
        <Col span={2}>MRP</Col>
        <Col span={2}>Available Quantity</Col>
        <Col span={1}>Unit</Col>
        <Col span={2}>Material Type</Col>
        <Col span={2}>Stock Value as per Online Record</Col>
        <Col span={2}>Physically Verified Stock as on 31.03.2026</Col>
        <Col span={2}>Stock Value Post Verification as on 31.03.2026</Col>
        <Col span={1}>Qty Variance</Col>
        <Col span={2}>Stock Value Variance</Col>
        <Col span={2}>Remarks</Col>
        <Col span={1}>Remove</Col>
        <Col span={1}>Add</Col>
        <Divider />
      </Row>
      {props.value.productDetails?.map((product, index) => (
        <div key={'products' + index}>
          <Row>
            <Col span={1}>{index + 1}.</Col>
            <Col span={3}>
              <ProductDropDown
                onSelect={(e, f) => {
                  props.productObjChangeHandler((f as any).props.label, index);
                  props.productChangeHandler(
                    { target: { name: 'productId', value: String(e) } },
                    index,
                  );
                }}
                allowClear
                extrafields={[
                  `sellingRate
                  materialType
                  unit {
                      name
                    }
                    stock(
                      branchId: "${
                        props.currentBusiness.type === 'branch'
                          ? props.currentBusiness.id
                          : ''
                      }",
                      companyId: "${props.company.id}",
                      date: "${moment(props.value.date).format('YYYY-MM-DD')}"
                    ) {
                      totalStocks
                    }
                    physicalStock(
                      branchId: "${
                        props.currentBusiness.type === 'branch'
                          ? props.currentBusiness.id
                          : ''
                      }",
                      companyId: "${props.company.id}"
                    ) {
                      physicalStock
                      stockRemarks
                    }
                    `,
                ]}
                company={props.company}
                value={product.productId || ''}
              />
            </Col>
            <Col span={2}>
              <TSInput
                error=""
                type="number"
                value={product.rate || 0}
                name="rate"
                placeholder="rate"
                required
                tabIndex={-1}
                disabled
              />
            </Col>
            <Col span={2}>
              <TSInput
                error=""
                type="number"
                value={product.quantity || 0}
                name="quanity"
                placeholder="Software Stock"
                required
                tabIndex={-1}
                disabled
              />
            </Col>
            <Col span={1}>
              <TSInput
                error=""
                type="text"
                value={product.unitName || ''}
                name="Unit"
                placeholder="Unit"
                required
                tabIndex={-1}
                disabled
              />
            </Col>
            <Col span={2}>
              <TSInput
                error=""
                type="text"
                value={product.materialType || ''}
                name="materialType"
                placeholder="Material Type"
                required
                tabIndex={-1}
                disabled
              />
            </Col>
            <Col span={2}>
              <TSInput
                error=""
                type="number"
                value={(product.rate || 0) * (product.quantity || 0) || 0}
                name="stockValue"
                placeholder="Stock Value"
                required
                tabIndex={-1}
                disabled
              />
            </Col>
            <Col span={2}>
              <TSInput
                error=""
                type="number"
                value={props.value.physicalStocks?.[index]}
                name="physical_stock"
                placeholder="Phyiscal Stock"
                onChange={(e) => props.physicalQuantityChangeHandler(e, index)}
                required
              />
            </Col>
            <Col span={2}>
              <TSInput
                error=""
                type="number"
                value={
                  (props.value.physicalStocks?.[index] || 0) *
                  (product.rate || 0)
                }
                name="stockValuePostVerification"
                placeholder="stock Value Post Verification"
                required
                tabIndex={-1}
                disabled
              />
            </Col>
            <Col span={1}>
              <TSInput
                error=""
                type="number"
                value={
                  (product.quantity || 0) -
                    (props.value.physicalStocks?.[index] || 0) || 0
                }
                name="qrtVariance"
                placeholder="Quantity Variance"
                required
                tabIndex={-1}
                disabled
              />
            </Col>
            <Col span={2}>
              <TSInput
                error=""
                type="number"
                value={
                  (product.rate || 0) * (product.quantity || 0) -
                    (props.value.physicalStocks?.[index] || 0) *
                      (product.rate || 0) || 0
                }
                name="amountVariance"
                placeholder="Amount Variance"
                required
                tabIndex={-1}
                disabled
              />
            </Col>
            <Col span={2}>
              <TSInput
                error=""
                type="text"
                value={product.stockRemarks || ''}
                name="stockRemarks"
                placeholder="Remarks"
                onChange={(e) => props.productChangeHandler(e, index)}
              />
            </Col>
            <Col span={1}>
              <Button
                type="primary"
                shape="circle"
                icon="minus"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  props.updateProductsRow('-', index);
                }}
                disabled={props.value.productDetails?.length === 1}
              />
            </Col>
            <Col span={1}>
              <Button
                type="primary"
                shape="circle"
                icon="plus"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  props.updateProductsRow('+', index);
                }}
                disabled={
                  product.productId &&
                  props.value.physicalStocks?.[index] !== null
                    ? false
                    : true
                }
              />
            </Col>
          </Row>
        </div>
      ))}
      <Row>
        <Col span={24}>
          <Checkbox
            checked={props.value.declarationIsChecked || false}
            onChange={(e) =>
              props.onChange({
                target: {
                  name: 'declarationIsChecked',
                  value: e.target.checked,
                },
              })
            }
          >
            I hereby declare that the stock maintained at the Johar
            Emporium/Production Center/Readymade Production center/Central Store
            has been duly verified based on physical verification and available
            records and is found to be accurate to the best of my knowledge and
            belief. A signed copy of the reconciliation/corrections is attached
            for reference. In case any discrepancies are identified in the
            future, the concerned staff responsible for stock maintenance shall
            be held accountable, subject to verification and as per applicable
            rules
          </Checkbox>
        </Col>
      </Row>
    </Row>
  );
};

interface Props {
  value: KhadiPhysicalStockNode;
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => void;
  company: CompanyNodeEdge;
  currentBusiness: Bussiness;
  productObjChangeHandler: (value: ProductNode, index: number) => void;
  productChangeHandler: (
    e: { target: { name: string; value: string } },
    index: number,
  ) => void;
  updateProductsRow: (type: string, index: number) => void;
  physicalQuantityChangeHandler: (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => void;
}
